import React, { Component } from 'react';

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

/* React Router */
import { withRouter } from 'react-router-dom'

/* Result */
import Result from 'iotera-base/result'

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { actions as notificationActions } from '../../redux/ducks/notification'
import { buildWBoundActions, buildWSelector } from '../../redux/ducks'

/* Routes */
import { domainIsTenant as dit, S, domain } from '../../routes/routes'

/* Object Json */
import { safeDeepGetWithType, parse, safeDeepGet, stringify, size, clean } from 'iotera-base/json';

import { isEmpty } from 'iotera-base/object';
import { SubViewHeader } from '../../lib/components/subHeader';
import { Button, TextField, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';

// import './style.scss'

import { DialogVarAdd } from '../dashboard-add-component/dialog/var-add';
import { DialogVarList } from '../dashboard-add-component/dialog/var-list';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

// import CSVReader from 'react-csv-reader'

const ADD = "ADD";
const WKEY = "DASHBOARD_ADD";
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

class DashboardAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props;
    const domainIsTenant = dit(_props);
    const domains = domain(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        wparam: { ...domainIsTenant, path: "/service/web/application/nav/list" },
        wcallback: {
          started: function (id) {
            // TODO Loading
            _this.setState({
              loading: true
            })
          },
          finished: function (id, result) {
            // TODO Loading
            _this.setState({
              loading: false,
            })
          }
        }
      }
    );

    _props.wSetConfig({
      single_config: {
        [ADD]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/application/nav/add"
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({ loading: false })
                  // Magic to refresh routes
                  _props.history.push('..')
                  _props.history.push('..' + S + domains + S + '_dashboard_list_')
                  _props.showSingleNotification({ message: 'Tambah Dashboard Sukses', level: 'success' });
                  return;
                }
              }
              _this.setState({ loading: false })
              _props.showSingleNotification({ message: 'Tambah Dashboard Gagal', position: 'tr', level: 'error' });
            }
          }
        }
      }
    });
  }

  componentWillUnmount() {
    // callback global
    const _props = this.props
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ single_config: WKEY });
  }

  goTo(link) {
    this.props.history.push(link)
  }

  handleSubmit() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const label = safeDeepGetWithType(_state, ['label'], '');
    if (label === '') {
      _props.showSingleNotification({ message: 'Nama dashboard tidak boleh kosong', level: 'warning' });
      return;
    }
    const desc = safeDeepGet(_state, ['desc']);
    let parent = safeDeepGet(_state, ['parent']);
    if (parent === '') {
      parent = null
    }
    let refreshString = safeDeepGet(_state, ['refresh'])
    if (refreshString === '') {
      _props.showSingleNotification({ message: 'Refresh rate tidak boleh kosong!', level: 'error' });
      return;
    }
    let refresh = parseInt(refreshString);
    if (refresh !== 0 && refresh < 500) {
      _props.showSingleNotification({ message: 'Refresh rate harus lebih besar dari 500 (ms) atau 0 (untuk auto)!', level: 'error' });
      return;
    }
    const decimal = safeDeepGetWithType(_state, ['decimal'], 2);
    let _var = safeDeepGetWithType(_state, ['_var'], {});
    for (let key in _var) {
      delete _var[key]._varType;
    }
    let view = { decimal }
    let config = { refresh }
    clean(config)
    let varToShow = isEmpty(_var) ? "" : `, "var" : ${stringify(_var)}`
    let configToShow = isEmpty(config) ? "" : `, "config" : ${stringify(config)}`
    let dashboard = `{ "version" : "2", "view" : ${stringify(view)}${configToShow}${varToShow}}`
    let conf_dashboard = parse(dashboard)
    let dashboardBody = {
      label,
      conf_dashboard,
      parent,
      desc
    }
    clean(dashboardBody);
    _this.setState({ loading: true });
    _props.wSingleRequestCall({
      id: ADD,
      body: dashboardBody
    });
  }

  handleChange(event) {
    const name = safeDeepGetWithType(event, ['target', 'name'], '')
    const value = safeDeepGet(event, ['target', 'value'], '')
    this.setState({ [name]: value })
  }

  render() {
    const _this = this
    const _state = _this.state
    const _props = _this.props
    const { loading } = _state;
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    let label = safeDeepGetWithType(_state, ['label'], '')
    let desc = safeDeepGetWithType(_state, ['desc'], '')
    let refresh = safeDeepGetWithType(_state, ['refresh'], '0')
    let decimal = safeDeepGetWithType(_state, ['decimal'], 2)
    let parent = safeDeepGetWithType(_state, ['parent'], '')
    let varLocal = safeDeepGetWithType(_state, ['_var'], {})
    let varLocalLength = size(varLocal)
    let items = safeDeepGetWithType(_props, ['items'], {});
    let parentItems = []
    for (let keys in items) {
      let currItem = items[keys]
      let id = safeDeepGet(currItem, ['id'])
      let label = safeDeepGet(currItem, ['label'])
      parentItems.push(
        <MenuItem value={id}>{label}</MenuItem>
      )
    }
    let length = parentItems.length;
    if (length > 0) {
      parentItems = [<MenuItem key={null} value={null}><em>None</em></MenuItem>].concat(parentItems)
    }
    length = parentItems.length;
    const refreshInt = parseInt(refresh)
    let errorRefresh = (refreshInt !== 0 && refreshInt < 500) || isNaN(parseInt(refresh))
    let refreshHelper = 'Refresh rate dalam satuan milisecond (ms), akan di-set auto jika refresh rate = 0'
    if (errorRefresh) {
      refreshHelper = 'Refresh rate harus merupakan angka >= 500 atau 0'
    }
    return (
      <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
        <div className="view">
          <SubViewHeader title='Tambah Dashboard' subTitle='Formulir Tambah Dashboard' />
          <div className="io-container mt-12">
            <form>
              <FormControl style={{ minWidth: '100%' }} >
                <TextField
                  label="Nama Dashboard"
                  value={label}
                  autoFocus
                  required
                  onChange={_this.handleChange}
                  type="string"
                  margin='dense'
                  inputProps={{ name: "label" }}
                />
              </FormControl>
              <FormControl style={{ minWidth: '100%' }} >
                <TextField
                  label="Deskripsi Dasboard"
                  value={desc}
                  onChange={_this.handleChange}
                  type="string"
                  margin='dense'
                  inputProps={{ name: "desc" }}
                />
              </FormControl>
              <FormControl style={{ minWidth: '45%', marginRight: 10 }} >
                <TextField
                  error={errorRefresh}
                  label="Refresh Rate"
                  value={refresh}
                  onChange={_this.handleChange}
                  type="number"
                  margin='dense'
                  inputProps={{ name: "refresh", min: "500", step: "1" }}
                  helperText={refreshHelper}
                />
              </FormControl>
              <FormControl required style={{ minWidth: '45%', marginRight: 10, marginTop: 5 }}>
                <InputLabel>Desimal yang akan ditampilkan</InputLabel>
                <Select
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  value={decimal}
                  onChange={_this.handleChange}
                  inputProps={{
                    name: 'decimal'
                  }}
                >
                  <MenuItem value={0}>0</MenuItem>
                  <MenuItem value={1}>0.1</MenuItem>
                  <MenuItem value={2}>0.01</MenuItem>
                  <MenuItem value={3}>0.001</MenuItem>
                  <MenuItem value={4}>0.0001</MenuItem>
                  <MenuItem value={5}>0.00001</MenuItem>
                </Select>
              </FormControl>
              {length > 0 &&
                <FormControl style={{ minWidth: '100%' }} >
                  <InputLabel>Parent</InputLabel>
                  <Select
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    value={parent}
                    onChange={_this.handleChange}
                    inputProps={{
                      name: 'parent'
                    }}
                  >
                    {parentItems}
                  </Select>
                </FormControl>
              }
              <DialogVarList _parent={_this} isGlobal={true} />
              <DialogVarAdd _parent={_this} />
              <div className='row' style={{ minWidth: '100%', marginTop: 10 }} >
                <div className='col-md-6' style={{ marginTop: 10 }}>
                  <span>
                    {varLocalLength > 0 &&
                      <Button variant="outlined" type="button" onClick={(e) => _this.setState({ dialogListVar: true, hasAction: true })}
                        style={{ marginRight: 10 }} >List Variabel</Button>
                    }
                    <Button variant='outlined' color='primary' onClick={(e) => _this.setState({ dialogAddVar: true })} >
                      Tambah Variabel
                    </Button>
                  </span>
                </div>
                <div className='col-md-6 button-right' style={{ marginTop: 10 }}>
                  <Button variant="outlined" type="button" size="large" style={{ minWidth: '0%' }}
                    onClick={(e) => _this.goTo('.' + S + '_dashboard_list_')} >Batal</Button>
                  <Button variant="contained" size="large" color="primary" onClick={_this.handleSubmit}
                    style={{ marginLeft: 10, minWidth: '0%' }}>Simpan</Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Loader>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    items: wSelector.getSoleInitMappedRPayload(state, 'navs')
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DashboardAdd));